import { ApiNames } from "components/Common/ApiManagement/apiServices";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../store/actions";
import { handleErrors, showToaster } from "components/Common/common";
import { PAGEPATHS, USERTYPES } from "components/Common/Constant";
import { useEffect, useState } from "react";

const GitHubLoginComp = () => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* ---------------------------------------------------
     LISTEN CODE FROM POPUP
  --------------------------------------------------- */
  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === "GITHUB_LOGIN_CODE") {
        try {
          setIsLoading(true);

          const { data } = await axiosInstance.post(
            ApiNames.GITHUB_AUTH,
            {
              code: event.data.code,
              mode: "login"          // 🔥 IMPORTANT
            }
          );

          if (data.status === 1) {
            dispatch(getUser(data.data));
            showToaster(1, data.message);

            data.data.userType === USERTYPES.Admin
              ? navigate(PAGEPATHS.Scanlist)
              : navigate(PAGEPATHS.StartAScan);

          } else {
            // Account exists but wrong provider OR not found
            showToaster(0, data.message);
          }

        } catch (err) {
          handleErrors(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  /* ---------------------------------------------------
     REDIRECT TO GITHUB
  --------------------------------------------------- */
  const loginWithGitHub = () => {
    const redirectUri = `${window.location.origin}/oauth/github/callback`;

    const githubAuthUrl =
      `https://github.com/login/oauth/authorize` +
      `?client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&scope=user:email` +
      `&state=login`;   // 🔥 for clarity

    window.open(githubAuthUrl, "githubLogin", "width=600,height=700");
  };

  return (
    <div style={{ placeSelf: "center", width: "92%" }}>

      <button
        id="github-login"
        disabled={isLoading}
        className={`login-w-g ${isLoading && "pe-none"}`}
        onClick={loginWithGitHub}
        style={{ background: "#24292f", color: "#fff" }}
      >
        {isLoading && <div className="loader-container"></div>}

        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white">
          <path d="M12 .5C5.73.5.5 5.74.5 12.03c0 5.11 3.29 9.44 7.86 10.97.58.1.79-.25.79-.56v-2.02c-3.2.7-3.88-1.54-3.88-1.54-.52-1.32-1.27-1.67-1.27-1.67-1.04-.71.08-.7.08-.7 1.15.08 1.75 1.18 1.75 1.18 1.02 1.75 2.68 1.25 3.33.96.1-.74.4-1.25.72-1.53-2.55-.29-5.23-1.28-5.23-5.7 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.18 1.18a10.9 10.9 0 0 1 2.9-.39c.98 0 1.97.13 2.9.39 2.2-1.49 3.17-1.18 3.17-1.18.62 1.58.23 2.75.11 3.04.74.81 1.18 1.84 1.18 3.1 0 4.43-2.69 5.4-5.25 5.68.41.36.77 1.07.77 2.15v3.18c0 .31.21.67.8.56 4.56-1.53 7.85-5.86 7.85-10.97C23.5 5.74 18.27.5 12 .5z" />
        </svg>

        <span>Sign in with GitHub</span>
      </button>
    </div>
  );
};

export default GitHubLoginComp;
